<template>
  <div class="incubatorManage">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="孵化组名称：">
          <el-input v-model="filter.incubateName" placeholder="请输入孵化组名称" />
        </el-form-item>
        <el-form-item label="当前状态：">
          <el-select v-model="filter.status" placeholder="请选择当前状态">
            <el-option label="全部" :value="null" />
            <el-option label="正常" :value="1" />
            <el-option label="已解散" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="date1"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 10px;">
      <el-row>
        <el-button type="primary" size="small" @click="handleAdd">添加孵化组</el-button>
        <el-button size="small" @click="handleDownload">下载导入模板</el-button>
      </el-row>
      <el-table v-loading="loading" :data="list" border style="margin-top: 10px">
        <el-table-column align="center" label="孵化组名称" prop="incubateName" min-width="150" />
        <el-table-column align="center" label="组长姓名" prop="leaderName" min-width="150" />
        <el-table-column align="center" label="组员人数" prop="memberNo" min-width="150" />
        <el-table-column align="center" label="状态" prop="status" min-width="150">
          <template v-slot="{ row }">
            <span v-if="row.status === 1">正常</span>
            <span v-else-if="row.status === 2">已解散</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="最后修改时间" prop="lastUpdateDate" min-width="158" />
        <el-table-column align="center" label="最近生效时间" prop="effectDate" min-width="158" />
        <el-table-column align="center" label="最后操作人" prop="lastUpdateName" min-width="150" />
        <el-table-column align="center" label="创建时间" prop="insertDate" min-width="158" />
        <!-- <el-table-column align="center" label="投诉人联系方式" prop="payerPhone" width="120">
          <template v-slot="{ row }">
            <span v-if="row.payerPhone">{{ row.payerPhone }}</span>
            <span v-else>用户未提供</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="操作" prop="" width="168" fixed="right">
          <template v-slot="{ row }">
            <template v-if="row.status === 1">
              <el-button type="text" @click="handleDismiss(row.id)">解散</el-button>
              <el-button type="text" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" @click="handleLeadingIn(row.id)">导入成员</el-button>
            </template>
            <el-button v-else-if="row.status === 2" type="text" @click="handleDel(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <GroupManage ref="groupManage" @refresh="getList" />

    <input
      ref="uploadEl"
      type="file"
      name="uploadFile"
      style="display: none"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
      @change="handleUpload"
    >
  </div>
</template>
<script>
import GroupManage from './modules/groupManage.vue'
import { getListPage, dismissBaseIncubate, delBaseIncubate, importSale } from '@/api/incubator/index.js'
import { baseURL } from '@/api/request'

export default {
  name: 'IncubatorManage',

  components: { GroupManage },
  data() {
    return {
      loading: false,
      filter: {
        page: 1,
        limit: 10,
        incubateName: '',
        status: null,
        insertStartDate: '',
        insertEndDate: ''
      },
      total: 0,
      list: [],
      currentIncubateId: null
    }
  },
  computed: {
    date1: {
      get() {
        return [this.filter.insertStartDate, this.filter.insertEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.insertStartDate = v[0] + ' 00:00:00' || ''
          this.filter.insertEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.insertStartDate = ''
          this.filter.insertEndDate = ''
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.filter.page = 1
      this.getList()
    },
    reset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    handleAdd() {
      this.$refs.groupManage.init()
    },
    handleDownload() {
      window.open(`${baseURL}/analyse/adm/baseIncubateSale/exportTemplate`)
    },
    getList (refresh = false) {
      this.loading = true
      const params = { ...this.filter }
      getListPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.total = Number(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleDismiss(id) {
      this.$confirm('是否确认解散当前孵化组？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const { code } = await dismissBaseIncubate({ id })
            if (code === 0) {
              this.$message.success('删解散成功！')
              this.getList()
            }
          } catch (error) {
            //防止request返回reject
          }
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.groupManage.init(row)
    },
    handleLeadingIn(id) {
      this.currentIncubateId = id
      this.$refs.uploadEl.value = ''
      this.$refs.uploadEl.click()
    },
    // 上传文件
    handleUpload({ target }) {
      if (target.files && target.files.length !== 0) {
        const form = new FormData()
        form.append('file', target.files[0])
        form.append('incubateId', this.currentIncubateId)
        importSale(form).then(({ code, data }) => {
          if (code === 0) {
            let successList = data[0]
            let failList = data[1]
            let successLen = successList.length
            let failLen = failList.length
            let message = "导入完毕！成功" + successLen + "条，失败" + failLen + "条"
            message += "<br>若成员显示不全，请点击刷新"
            message += "<br>请稍后。。直到成员显示完全才可再次导入"
            if (failLen > 0) {
              message += "<div style='max-height:500px;overflow:auto'><div style='margin:5px'>"
              message += "失败手机号如下："
              for (let index = 0; index < failLen; index++) {
                const element = failList[index];
                message += element.salePhone + ",\n"
              }
              message += "</div></div>"
            }
            this.$notify({
              title: '导入完毕！',
              dangerouslyUseHTMLString: true,
              message,
              duration: 0
            });
          }
        })
      }
    },
    handleDel(id) {
      this.$confirm('确定要删除当前孵化组吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const { code } = await delBaseIncubate({ id })
            if (code === 0) {
              this.$message.success('删除成功！')
              this.getList()
            }
          } catch (error) {
            //防止request返回reject
          }
        })
        .catch(() => {})
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  },
};
</script>
<style scoped lang="scss">

</style>
